import SearchData from "../View/SearchData";

const LeftHeader = () => (
  <div className="flex items-center justify-between px-4 pt-2 border-b bg-gray-50">
    <SearchData />
  </div>
);

export default LeftHeader;